"use client";

import { Button } from "@/components/ui/button";

export default function RegisterError({ reset }: { error: Error; reset: () => void }) {
  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center gap-4">
      <p className="text-sm text-muted-foreground">
        오류가 발생했습니다. 잠시 후 다시 시도해주세요.
      </p>
      <Button onClick={reset} variant="outline">
        다시 시도
      </Button>
    </div>
  );
}
